import { getToken as getClerkToken } from '@clerk/react';

/**
 * Frontend dual-mode auth switch (bead jooice-knv9, jooice-r8oi). Mirrors the backend's
 * `AUTH_ISSUERS` gate: when `VITE_CLERK_PUBLISHABLE_KEY` is unset (the default, every
 * deployment today), the login page renders the existing Outseta form byte-identically —
 * nothing in this file, or anything it gates, executes. Only a real publishable key
 * (set in `jooice-local/.env.local` for local rehearsal) switches the login screen to the
 * headless Clerk flow.
 */
export function isClerkAuthEnabled(): boolean {
  return Boolean(import.meta.env.VITE_CLERK_PUBLISHABLE_KEY);
}

declare global {
  interface Window {
    Clerk?: { signOut?: () => Promise<void> };
  }
}

export async function getAuthToken(): Promise<string | null> {
  if (!isClerkAuthEnabled()) return localStorage.getItem('Outseta.nocode.accessToken');
  return getClerkToken();
}

export async function signOutClerk(): Promise<void> {
  if (isClerkAuthEnabled()) await window.Clerk?.signOut?.();
}
